<template lang="pug">
     .section(
        :class='theme',
        v-observe-visibility='visibilityChanged'
        ref='section'
        )
        ScrollTrigger(
            :color='theme',
            :position='"top"'
            )
    
        .textwrapper
            .section-heading(v-if='content.title')
                ArticleTitle(:title='content.title', :color='theme', :isActive='isActive')
            .section-block(
                v-for='(block, blockIndex) in content.content',
                :class='[block.position, block.modifier]'
                :data-section-block-index='blockIndex'
                )
                .texts(v-if='block.type === "text"' :isActive='isActive')
                    .texts__wrap(v-html='block.textblocks.join("")')
                    .texts__side-illustration(v-if='block.illustrations')
                        component(v-if='ill.type' v-for='ill, index in block.illustrations' :is='ill.type' :name='ill.name' :isActive='isActive' :text='ill.text' :value='ill.value' :side='block.position' :key='`${ill}-${index}`' :color='theme') 
                .image-fullsize(v-else-if='block.type === "ArticleImage"')
                    ArticleImage(:name='block.name' :text='block.text' :alt='block.text' :isActive='isActive')
                .animation-block(v-else-if='block.type === "animationBlock"')
                    AnimationBlock(:isActive='isActive' :theme='block.theme' :name='block.name')
                .animation-block(v-else-if='block.type === "statement"')
                    Statement(:content='block.content')
                .animation-block(v-else-if='block.type === "helpOrientation"')
                    HelpOrientation(:content='block.content')
                    
</template>
<script>
import {gsap} from 'gsap';
import * as basicScroll from 'basicscroll';
export default {
    components: {
        ArticleImage: () => import('../components/illustrations/ArticleImage'),
        ArticleTitle: () => import('../components/ArticleTitle'),
        Counter: () => import('../components/illustrations/Counter'),
        Animation: () => import('../components/illustrations/Animation'),
        AnimationBlock: () => import('../components/illustrations/AnimationBlock'),
        Quote: () => import('../components/illustrations/Quote'),
        Statement: () => import('../components/Statement'),
        HelpOrientation: () => import('../components/HelpOrientation'),
        ScrollTrigger: () => import('../components/ScrollTrigger')
    },
    props: {
        theme: String,
        content: Object
    },
    data() {
        return {
            isActive: false
        };
    },
    methods: {
        visibilityChanged(isVisible) {
            if (isVisible) {
                this.isActive = true;
                if (document.documentElement.clientWidth < 768) {
                    this.createQuoteAnimation();
                }
            } else {
                this.isActive = false;
                this.destroyQuoteAnimation();
            }
        },
        destroyQuoteAnimation() {
            if (this._quotesMobInst) {
                this._quotesMobInst.forEach(item => {
                    if (item) {
                        item.destroy();
                        item = null;
                    }
                });
            }
        },
        createQuoteAnimation() {
            this.timeline = gsap.timeline();
            this._quotesMobInst = [];
            let quotesMobile = this.$refs.section.querySelectorAll('.quote-mobile');
            quotesMobile.forEach((item, index) => {
                const inst = basicScroll.create({
                    elem: item,
                    from: 'top-bottom',
                    to: 'bottom-middle',
                    direct: true,
                    props: {
                        '--translateQ': {
                            from: 0,
                            to: 1
                        }
                    }
                });
                inst.start();
                if (index % 2) {
                    item.style.transform = `translateX(calc(-30% + var(--translateQ) * 30%))`;
                    return;
                }
                item.style.transform = `translateX(calc(30% - var(--translateQ) * 30%))`;
                return;
            });
        }
    }
};
</script>
<style lang="scss">
.quote-mobile {
    @media (--viewport-tablet) {
        display: block;
        font-family: var(--font-accent);
        font-weight: bold;
        font-size: 1.25rem;
        color: inherit;
        margin: 20px 0 20px;
        padding-left: var(--grid-column-mobile);
    }
}

.section {
    &.black {
        .quote-mobile {
            color: var(--color-white);
        }
    }
}
</style>
